import React, { useState } from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import './ProfilePhoto.css';

// Read photos already supplied by the profile source. Never start an enrichment
// request for a photo, and do not reuse the old stock portrait as a real person.
export function getProfilePhoto(...records) {
  for (const record of records) {
    for (const field of ['photo_url', 'profile_pic_url', 'picture', 'photoUrl', 'photoURL', 'profile_picture_permalink']) {
      const value = record?.[field];
      if (typeof value !== 'string' || !value.trim()) continue;
      const src = value.trim();
      if (!/^https?:\/\//i.test(src) && !/^\/(?!\/)/.test(src)) continue;
      try {
        const url = new URL(src, window.location.origin);
        if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) continue;
        if (url.pathname.toLowerCase().endsWith('/ex-profile.jpg')) continue;
        return src;
      } catch { /* Ignore malformed photo values and try the next saved field. */ }
    }
  }
  return '';
}

export default function ProfilePhoto({ src, alt = '' }) {
  const photo = getProfilePhoto({ photo_url: src });
  const [failedPhoto, setFailedPhoto] = useState('');
  return <div className="profile-photo">
    {photo && photo !== failedPhoto
      ? <img className="profile-photo__image" src={photo} alt={alt} onError={() => setFailedPhoto(photo)} />
      : <svg className="profile-photo__icon" viewBox={`0 0 ${faUser.icon[0]} ${faUser.icon[1]}`} aria-hidden="true" focusable="false">
        <path fill="currentColor" d={faUser.icon[4]} />
      </svg>}
  </div>;
}
